import React from 'react'
import style from '../style.module.css'
import { Logo } from '../../../assets'
import { NavLink } from "react-router-dom";
// import { Button } from '../../buttons';

const MainNav = () => {

    return (
        <nav className={['main__nav', style.main__nav_wrapper].join(" ")}>
            <Logo />
            <ul>
                <NavLink
                    to="/"
                    className={({ isActive, isPending }) =>
                        isPending ? "pending" : isActive ? style.active : ""
                    }
                >
                    Home
                </NavLink>
                {/* <NavLink
                    to="#"
                    className={({ isActive, isPending }) =>
                        isPending ? "pending" : isActive ? style.active : ""
                    }
                >
                    Services
                </NavLink> */}
                <NavLink
                    to="/about-us"
                    className={({ isActive, isPending }) =>
                        isPending ? "pending" : isActive ? style.active : ""
                    }
                >
                    About Us
                </NavLink>
                <NavLink
                    to="/contact-us"
                    className={({ isActive, isPending }) =>
                        isPending ? "pending" : isActive ? style.active : ""
                    }
                >
                    Contact Us
                </NavLink>

            </ul>
            {/* <Button
                children={'Get a Quote'}
                onClick={() => console.log('first')}
            /> */}
        </nav>
    )
}

export default MainNav